import React from 'react';
import Navbar from '../components/Internal-nav';  
import ContactBanner from '../components/contact-banner';
import './home.scss';

function Flooring() {


  return (
    <div className='configure-page'>
      <header>
        <Navbar />
      </header>
      <div className='inner-banner' style={{ backgroundImage: "url(../assets/configure-banner.jpg)" }}>
        <div className='banner-content'>
          <h1>Flooring</h1>
        </div>
      </div>
      <div className='container'>
        <div className='flooring-info'>
        <h2>Proud Distributor of Shaw Flooring Products</h2>
        <img src="../assets/shaw_floors_logo.jpeg" alt="Shaw Flooring Products" />
        <p>BC Surface Supply is proud to offer <a href="https://shawfloors.com/">Shaw Flooring products</a>. Shaw is a leading flooring manufacturer and distributor, providing a wide range of flooring options for residential and commercial spaces. Whether you’re looking for hardwood, laminate, tile, or carpet, Shaw has the perfect flooring solution for your home or business.</p>
      </div>
      </div>
      <ContactBanner></ContactBanner>
    </div>
  );
}

export default Flooring;
